import { ModalAssinatura } from "@/components/ModalAssinatura";
import { IFormValuesTermoNotificacao } from "@/interfaces/IFormValuesTermoNotificacao";
import { cpfMask } from "@/utils/cpfMask";
import { ClearOutlined, SignatureOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  FormInstance,
  Input,
  Radio,
  RadioChangeEvent,
  Row,
  Typography,
} from "antd";
import { useRef, useState } from "react";
import ReactSignatureCanvas from "react-signature-canvas";

export function AssinaturaTermoNotificacao({
  form,
}: {
  form: FormInstance<IFormValuesTermoNotificacao>;
}) {
  const [isOpenModalServidor, setIsOpenModalServidor] = useState(false);
  const [isOpenModalFiscalizado, setIsOpenModalFiscalizado] = useState(false);
  const refAssinante = useRef<ReactSignatureCanvas>(null);
  const refServidor = useRef<ReactSignatureCanvas>(null);
  const statusAssinatura = Form.useWatch("statusAssinatura", form);
  const assinaturaServidor = Form.useWatch("assinaturaServidor", form);
  const assinaturaFiscalizado = Form.useWatch("assinaturaFiscalizado", form);

  const viewAssinaturas =
    statusAssinatura !== undefined &&
    statusAssinatura !== "ASSINADO_FISICAMENTE";

  const limparAssinatura = (signature?: ReactSignatureCanvas | null) => {
    if (signature !== null && signature !== undefined) {
      signature.clear();
    }
  };

  const handleOpenModalFiscalizado = () => {
    setIsOpenModalFiscalizado(true);
  };

  const handleCloseModalFiscalizado = () => {
    setIsOpenModalFiscalizado(false);

    if (!refAssinante.current || refAssinante.current.isEmpty()) {
      form.resetFields(["assinaturaFiscalizado"]);
      return;
    }

    form.setFieldValue(
      "assinaturaFiscalizado",
      refAssinante.current?.toDataURL("image/png")
    );
  };

  const handleClearAssinaturaFiscalizado = () => {
    limparAssinatura(refAssinante.current);
    form.resetFields(["assinaturaFiscalizado"]);
  };

  const handleOpenModalServidor = () => {
    setIsOpenModalServidor(true);
  };

  const handleCloseModalServidor = () => {
    setIsOpenModalServidor(false);

    if (!refServidor.current || refServidor.current.isEmpty()) {
      form.resetFields(["assinaturaServidor"]);
      return;
    }

    form.setFieldValue(
      "assinaturaServidor",
      refServidor.current?.toDataURL("image/png")
    );
  };

  const handleClearAssinaturaServidor = () => {
    limparAssinatura(refServidor.current);
    form.resetFields(["assinaturaServidor"]);
  };

  const handleChangeStatusAssinatura = (e: RadioChangeEvent) => {
    form.setFieldValue("statusAssinatura", e.target.value);
    form.resetFields([
      "assinaturaServidor",
      "assinaturaFiscalizado",
      "nomeAssinante",
      "cpfAssinante",
      "funcaoAssinante",
    ]);

    limparAssinatura(refServidor.current);
    limparAssinatura(refAssinante.current);
  };

  return (
    <>
      <Col xs={24} sm={24}>
        <Form.Item
          name="statusAssinatura"
          rules={[
            { required: true, message: "Selecione o status da assinatura" },
          ]}
        >
          <Radio.Group onChange={handleChangeStatusAssinatura}>
            <Radio value="ASSINADO_FISICAMENTE">Assinatura Fisica</Radio>

            <Radio value="ASSINADO_DIGITALMENTE">Assinatura Digital</Radio>

            <Radio value="RECUSADO">Recusado</Radio>

            <Radio value="AUSENTE">Ausente</Radio>

            <Radio value="IMPOSSIBILITADO">Impossibilitado</Radio>

            <Radio value="NAO_ALFABETIZADO">Não Alfabetizado</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      {viewAssinaturas && (
        <Row
          style={{ marginTop: 20 }}
          gutter={[24, 24]}
          justify={"space-around"}
        >
          <Col xs={24} sm={24} md={12} lg={12} xl={8}>
            <Row justify={"center"} gutter={[8, 8]}>
              <Col span={12}>
                <Button
                  type="primary"
                  style={{ width: "100%" }}
                  icon={<SignatureOutlined />}
                  onClick={handleOpenModalServidor}
                >
                  Assinar
                </Button>
              </Col>

              <Col span={12}>
                <Button
                  type="default"
                  style={{ width: "100%" }}
                  icon={<ClearOutlined />}
                  onClick={handleClearAssinaturaServidor}
                >
                  Limpar
                </Button>
              </Col>
            </Row>

            <Row justify={"center"} style={{ marginTop: 10 }}>
              <Col
                span={24}
                style={{
                  border: "1px solid #ccc",
                  height: 400,

                  borderRadius: 8,
                }}
              >
                <Form.Item>
                  {assinaturaServidor && (
                    <img
                      src={assinaturaServidor}
                      alt="Assinatura Servidor"
                      style={{ width: "90%", height: "90%" }}
                    />
                  )}
                </Form.Item>

                <Form.Item
                  name="assinaturaServidor"
                  rules={[
                    { required: true, message: "Assinatura obrigatória" },
                  ]}
                  hidden
                >
                  <Input type="hidden" />
                </Form.Item>
              </Col>
            </Row>

            <Row justify={"center"} style={{ marginTop: 10 }}>
              <Col span={24} style={{ textAlign: "center" }}>
                <Typography.Text strong>Assinatura Notificante</Typography.Text>
              </Col>
            </Row>
          </Col>

          {statusAssinatura === "ASSINADO_DIGITALMENTE" && (
            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
              <Row justify={"center"} gutter={[8, 8]}>
                <Col span={12}>
                  <Button
                    type="primary"
                    style={{ width: "100%" }}
                    icon={<SignatureOutlined />}
                    onClick={handleOpenModalFiscalizado}
                  >
                    Assinar
                  </Button>
                </Col>

                <Col span={12}>
                  <Button
                    type="default"
                    style={{ width: "100%" }}
                    icon={<ClearOutlined />}
                    onClick={handleClearAssinaturaFiscalizado}
                  >
                    Limpar
                  </Button>
                </Col>
              </Row>

              <Row justify={"center"} style={{ marginTop: 10 }}>
                <Col
                  span={24}
                  style={{
                    border: "1px solid #ccc",
                    height: 400,
                    borderRadius: 8,
                  }}
                >
                  <Form.Item>
                    {assinaturaFiscalizado && (
                      <img
                        src={assinaturaFiscalizado}
                        alt="Assinatura Fiscalizado"
                        style={{ width: "100%", height: "100%" }}
                      />
                    )}
                  </Form.Item>

                  <Form.Item
                    name="assinaturaFiscalizado"
                    rules={[
                      { required: true, message: "Assinatura obrigatória" },
                    ]}
                    hidden
                  >
                    <Input type="hidden" />
                  </Form.Item>
                </Col>
              </Row>

              <Row justify={"center"} style={{ marginTop: 10 }} gutter={[8, 8]}>
                <Col span={24} style={{ textAlign: "center" }}>
                  <Typography.Text strong>
                    Assinatura Notificado
                  </Typography.Text>
                </Col>

                <Col xs={24} sm={8}>
                  <Form.Item
                    name="nomeAssinante"
                    rules={[{ required: true }]}
                    label="Nome"
                  >
                    <Input placeholder="Nome do Assinante" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8}>
                  <Form.Item
                    name="cpfAssinante"
                    rules={[{ required: true }]}
                    label="CPF"
                  >
                    <Input
                      placeholder="CPF do Assinante"
                      maxLength={14}
                      onChange={(e) => {
                        const { value } = e.target;
                        form.setFieldValue("cpfAssinante", cpfMask(value));
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8}>
                  <Form.Item
                    name="funcaoAssinante"
                    label="Função"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Função do Assinante" />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          )}
        </Row>
      )}

      <ModalAssinatura
        isOpen={isOpenModalFiscalizado}
        cleanSignature={limparAssinatura}
        handleClose={handleCloseModalFiscalizado}
        refAssinante={refAssinante}
        nomeAssinante="Notificado"
      />

      <ModalAssinatura
        isOpen={isOpenModalServidor}
        cleanSignature={limparAssinatura}
        handleClose={handleCloseModalServidor}
        refAssinante={refServidor}
        nomeAssinante="Notificante"
      />
    </>
  );
}
